import React, {Component} from 'react';
import {Divider, Icon} from 'semantic-ui-react';

class CustomDivider extends Component {
  render() {
    return (
      <Divider horizontal>
        <Icon name='dna' style={{color:'#555'}}/>
      </Divider>
    );
  }
}
export default CustomDivider;



// WEBPACK FOOTER //
// ./src/components/extras/CustomDivider.js